import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';

type ActionHook<A, S extends readonly string[]> = S extends readonly (infer X)[]
  ? {
      [T in Extract<X, string>]: (
        // @ts-ignore
        ...params: Parameters<A[T]>
      ) => // @ts-ignore
      ReturnType<ReturnType<A[T]>>;
    }
  : never;

/**
 * CAVEAT EMPTOR - this is a bit of voodoo, but it seems to work for live chat...
 *
 * There is a bit of `any` scattered about; beware, and test, test, test, when making changes.
 *
 * @param actionsInstance The action class instance that we're building a hook for
 * @param hookActionList The list of methods we want exposed on the hook
 */
export function getActionHookBuilder<
  ActionClass,
  ActionList extends Extract<keyof ActionClass, string>[],
>(actionsInstance: ActionClass, hookActionList: ActionList) {
  const useHook: () => ActionHook<ActionClass, ActionList> = () => {
    const dispatch: Dispatch<StoreState> = useDispatch();

    return useMemo(() => {
      const result: any = {};
      hookActionList.forEach(key => {
        result[key] = (...params: any[]) =>
          dispatch((actionsInstance[key] as any)(...params));
      });
      return result;
    }, [dispatch]);
  };
  return useHook;
}
